import { LanguageTestSection } from '../../lib/types/models/language-test/language-test-section'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deleteLanguageTestSection = (id: number) =>
  restApiClient
    .url(constructApiUrl(API.languageTest.deleteSection.url, { id }))
    .delete<LanguageTestSection>()
